module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['loading-container', _vm.showLoading && _vm.needMask && 'loading-need-mask'],
    style: (_vm._px2rem(_vm.maskStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.maskClicked($event)
      }
    }
  }, [(_vm.showLoading) ? _c('div', {
    staticClass: "dof-loading weex-ct weex-div",
    style: ({
      top: _vm._px2rem(_vm.topPosition + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['loading-box', _vm.loading.class, _vm.loadingText && _vm.loadingText.length > 5 && 'loadingMoreTextBox', _vm.loadingText && _vm.loadingText.length <= 5 && 'loadingTextBox'],
    attrs: {
      "aria-hidden": true,
      "weex-type": "div"
    }
  }, [_c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("contain"),
      expression: "\"contain\""
    }],
    staticClass: "loading-image weex-el weex-image",
    attrs: {
      "src": _vm.loading.url,
      "resize": "contain",
      "quality": "original",
      "data-img-src": _vm.loading.url,
      "weex-type": "image"
    }
  }), _vm._v(" "), (_vm.loadingText) ? _c('p', {
    staticClass: " weex-el weex-text",
    class: ['loading-text', _vm.loading.class == 'white-loading' ? 'blackText' : ''],
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s((_vm.loadingText.length <= 15) ? _vm.loadingText : _vm.loadingText.substr(0, 15)))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-080af9f7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-080af9f7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-loading/index.vue
// module id = 561
// module chunks = 0 1